export default __webpack_public_path__ + "static/media/383.49fad5df.gif";